import "./LinksPage.css";

const LOGO_SRC = "assets/images/logo/Logo.png";

const linksPageConfig = {
  brand: {
    name: "Dionara Krause",
    subtitle: "Estética Corporal, Facial & Nutrição",
    headline:
      "Cuidado personalizado em estética e nutrição, com orientação profissional.",
    info: "Atendimento rápido e individualizado",
  },

  contact: {
    whatsappUrl:
      "https://wa.me/5547997270336?text=Ol%C3%A1%2C%20vim%20pelo%20link%20da%20Dionara%20Krause%20e%20gostaria%20de%20agendar%20um%20atendimento.",
  },

  social: {
    facebook: "https://www.facebook.com/people/Nutri-Nara/61552130601203/?mibextid=YMEMSu",
    instagram: "https://www.instagram.com/nutri_nara_krause/",
  },
};

function WhatsAppIcon() {
  return (
    <svg
      className="links-page__whatsapp-svg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#fff"
        d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"
      />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#fff"
        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
      />
    </svg>
  );
}

export default function LinksPage() {
  return (
    <main className="links-page">
      <div className="links-page__dots links-page__dots--left-top">
        {Array.from({ length: 8 }).map((_, index) => (
          <span
            key={`left-${index}`}
            style={{ animationDelay: `${index * 0.12}s` }}
          />
        ))}
      </div>

      <div className="links-page__dots links-page__dots--card">
        {Array.from({ length: 12 }).map((_, index) => (
          <span
            key={`card-${index}`}
            style={{ animationDelay: `${index * 0.1}s` }}
          />
        ))}
      </div>

      <div className="links-page__dots links-page__dots--right-bottom">
        {Array.from({ length: 8 }).map((_, index) => (
          <span
            key={`right-${index}`}
            style={{ animationDelay: `${index * 0.14}s` }}
          />
        ))}
      </div>

      <div className="links-page__circle links-page__circle--top-right" />
      <div className="links-page__circle links-page__circle--bottom-left" />
      <div className="links-page__diamond links-page__diamond--one" />
      <div className="links-page__diamond links-page__diamond--two" />

      <section className="links-page__card" aria-label="Links Dionara Krause">
        <div className="links-page__logo-wrap links-page__item links-page__item--1">
          <div className="links-page__logo-circle">
            <div className="links-page__logo-inner">
              <img
                src={LOGO_SRC}
                alt="Logotipo Dionara Krause"
                className="links-page__logo"
              />
            </div>
          </div>
        </div>

        <h1 className="links-page__title links-page__item links-page__item--2">
          {linksPageConfig.brand.name}
        </h1>

        <p className="links-page__subtitle links-page__item links-page__item--3">
          {linksPageConfig.brand.subtitle}
        </p>

        <h2 className="links-page__headline links-page__item links-page__item--4">
          {linksPageConfig.brand.headline}
        </h2>

        <a
          href={linksPageConfig.contact.whatsappUrl}
          target="_blank"
          rel="noreferrer"
          className="links-page__whatsapp links-page__item links-page__item--5"
          aria-label="Falar no WhatsApp agora"
        >
          <span className="links-page__whatsapp-icon">
            <WhatsAppIcon />
          </span>
          <span>FALAR NO WHATSAPP AGORA</span>
        </a>

        <div className="links-page__info links-page__item links-page__item--6">
          <span className="links-page__check">✓</span>
          <span>{linksPageConfig.brand.info}</span>
        </div>

        <div className="links-page__divider links-page__item links-page__item--7" />

        <div className="links-page__socials links-page__item links-page__item--8">
          <a
            href={linksPageConfig.social.facebook}
            className="links-page__social links-page__social--facebook"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            data-label="Facebook"
          >
            <FacebookIcon />
          </a>

          <a
            href={linksPageConfig.social.instagram}
            className="links-page__social links-page__social--instagram"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            data-label="Instagram"
          >
            <InstagramIcon />
          </a>
        </div>
      </section>

      <footer className="links-page__footer">
        <p>© 2026 Clínica Integrada Dionara Krause</p>
        <span>
          Desenvolvido por{" "}
          <a href="https://hrtechsolutions.com.br" target="_blank" rel="noreferrer">
            HRTech Solutions
          </a>
        </span>
      </footer>
    </main>
  );
}